import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, resolveDirective as _resolveDirective, createVNode as _createVNode, withDirectives as _withDirectives, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createTextVNode as _createTextVNode, isRef as _isRef, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4d57ae34"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "setup-pwd rel" }
const _hoisted_2 = {
  key: 0,
  class: "text-ct permission rel"
}
const _hoisted_3 = { class: "tabs flex" }
const _hoisted_4 = ["hidden"]
const _hoisted_5 = ["onClick"]
const _hoisted_6 = {
  key: 0,
  class: "bomTag"
}
const _hoisted_7 = { class: "rel" }
const _hoisted_8 = ["src"]
const _hoisted_9 = { class: "gary-block flex-ter" }
const _hoisted_10 = { style: {"margin-left":"10px"} }
const _hoisted_11 = { class: "gary-block flex-ter" }
const _hoisted_12 = { style: {"margin-left":"10px"} }
const _hoisted_13 = { style: {"margin-left":"10px"} }
const _hoisted_14 = { class: "rel" }
const _hoisted_15 = ["src"]
const _hoisted_16 = { class: "rel" }
const _hoisted_17 = ["src"]
const _hoisted_18 = { class: "commit" }

import { ref, computed, reactive, WritableComputedRef, watch } from 'vue'
import { t } from '@/plugins/i18n'
import { setupPwd as createRules } from '@/views/signup/components/rules'
import { useGetCode, useLoading } from '@/views/signup/components/utils'
import {
  updatePassword,
  getForgotCode,
  updatePasswordByEmail,
  getMobileCode
} from '@/apis/login'
import { useStore } from 'vuex'
import useForm from '@/util/useForm'
import { ElMessage } from 'element-plus'
import SwitchRam from './components/SwitchRam.vue'


export default /*#__PURE__*/_defineComponent({
  props: ['customer', 'accounts', 'account'],
  emits: ['update:account'],
  setup(__props, { emit }) {

const props = __props
const store = useStore()


const faEyeSlash = require('@/assets/image/icon/fa-eye-slash.png')
const faEye = require('@/assets/image/icon/fa-eye.png')
console.log(props.customer, props.account)
const switchRamUpdate = (e: any) => {
  emit('update:account', e)
}

const cur = computed({
  get: () => store.state.status.setupChangePWD,
  set: (v) => store.commit('status/setupChangePWD', v)
})
const tabs = [{ label: '旧密码重置密码', hidden: false }, { label: '邮箱重置密码', hidden: !props.customer.customerEmail }, { label: '手机重置密码', hidden: !props.customer.customerMobile }].fort()

const texts = ['原密码', '邮箱', '验证码', '新密码', '再次确认新密码', '手机号'].map(text => t(text))

const tips = [
  '请输入原密码',
  '',
  '输入验证码',
  '请输入新密码',
  '请再次输入您的密码'
].map((v) => (v ? t(v) : v))

const prev = ref(true)
const pwc = ref(true)

const [loading, api] = useLoading(() => {
  const formData = { ...form, globalRoaming: props.customer.countryCode }
  if (props.customer.accountType !== 1) {
    // 子账号传customerId
    formData.customerId = props.customer.customerId
  }
  let returnApi = null
  if (cur.value === 0) {
    returnApi = updatePassword(formData)
  } else if (cur.value === 1) {
    delete formData.customerMobile
    returnApi = updatePasswordByEmail(formData)
  } else {
    delete formData.customerEmail
    returnApi = updatePasswordByEmail(formData)
  }
  return returnApi
})
const { count, tip, disabled, getCode, getPhoneCode } = useGetCode(
  'changeEmailCode',
  getForgotCode,
  getMobileCode
)

const [formRef, commit] = useForm(() => {
  api().then((res) => {
    if (res.success) {
    //   ElMessage.success(t('密码修改成功'))
      ElMessage.success(t('密码修改成功，请重新登录'))
      setTimeout(() => {
        store.commit('route/token', null)
        // debugger
        location.reload()
      }, 1000)
    }
  })
})

watch(cur, (v) => {
  formRef.value && formRef.value.resetFields()
})

const form: any = reactive({
  oldPassword: '',
  newPassword: '',
  repassword: '',
  customerEmail: props.customer.customerEmail,
  customerMobile: props.customer.customerMobile,
  verificationCode: ''
})
disabled.value = false
const rules = createRules(form, disabled)

return (_ctx: any,_cache: any) => {
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_form = _resolveComponent("el-form")!
  const _directive_main = _resolveDirective("main")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_unref(store).getters.isSub)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, _toDisplayString(_unref(t)('你的子账号没有修改权限，请联系主账号管理者修改你的密码')), 1))
      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
          _createElementVNode("div", _hoisted_3, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(tabs), (v, i) => {
              return (_openBlock(), _createElementBlock("div", {
                key: v.label,
                hidden: v.hidden
          
              }, [
                _createElementVNode("span", {
                  class: _normalizeClass([{ active: _unref(cur) === i }, "btn"]),
                  onClick: ($event: any) => (cur.value = i)
                }, _toDisplayString(v.label), 11, _hoisted_5),
                (_unref(cur) === i)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_6))
                  : _createCommentVNode("", true)
              ], 8, _hoisted_4))
            }), 128))
          ]),
          _createVNode(_component_el_form, {
            ref: (_value, _refs) => {
              _refs['formRef'] = _value
              _isRef(formRef) && (formRef.value = _value)
            },
            model: _unref(form),
            rules: _unref(rules),
            "label-width": "210px"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_form_item, {
                label: _unref(t)('切换账号')
              }, {
                default: _withCtx(() => [
                  _withDirectives(_createVNode(SwitchRam, {
                    account: __props.account,
                    accounts: __props.accounts,
                    onUpdate: switchRamUpdate,
                    style: {"width":"450px"}
                  }, null, 8, ["account", "accounts"]), [
                    [_directive_main]
                  ])
                ]),
                _: 1
              }, 8, ["label"]),
              (_unref(cur) === 0)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    (!__props.customer.initialPassword)
                      ? (_openBlock(), _createBlock(_component_el_form_item, {
                          key: 0,
                          prop: "oldPassword",
                          label: _unref(texts)[0]
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("div", _hoisted_7, [
                              _createVNode(_component_el_input, {
                                type: prev.value ? 'password' : 'text',
                                modelValue: _unref(form).oldPassword,
                                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(form).oldPassword) = $event)),
                                modelModifiers: { trim: true },
                                placeholder: _unref(tips)[0],
                                maxlength: 32
                              }, null, 8, ["type", "modelValue", "placeholder"]),
                              _createElementVNode("img", {
                                src: prev.value ? _unref(faEyeSlash) : _unref(faEye),
                                onClick: _cache[1] || (_cache[1] = ($event: any) => (prev.value = !prev.value)),
                                alt: "",
                                class: "abs btn eye primary fa"
                              }, null, 8, _hoisted_8)
                            ])
                          ]),
                          _: 1
                        }, 8, ["label"]))
                      : _createCommentVNode("", true)
                  ], 64))
                : (_unref(cur) === 1)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                      _createVNode(_component_el_form_item, {
                        label: _unref(texts)[1],
                        style: {"margin-bottom":"24px"}
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", _hoisted_9, [
                            _createElementVNode("span", _hoisted_10, _toDisplayString(_unref(form).customerEmail), 1)
                          ])
                        ]),
                        _: 1
                      }, 8, ["label"]),
                      _createVNode(_component_el_form_item, {
                        prop: "verificationCode",
                        label: _unref(texts)[2]
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_input, {
                            type: "text",
                            modelValue: _unref(form).verificationCode,
                            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(form).verificationCode) = $event)),
                            modelModifiers: { trim: true },
                            placeholder: _unref(tips)[2],
                            maxlength: 6,
                            style: {"width":"320px"}
                          }, null, 8, ["modelValue", "placeholder"]),
                          _createVNode(_component_el_button, {
                            class: "codebtn",
                            type: "primary",
                            onClick: _cache[3] || (_cache[3] = ($event: any) => (_unref(getCode)(_unref(form).customerEmail))),
                            disabled: _unref(count) > 0
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_unref(count)
              > 0 ? _unref(tip) : _unref(t)('获取验证码')), 1)
                            ]),
                            _: 1
                          }, 8, ["disabled"])
                        ]),
                        _: 1
                      }, 8, ["label"])
                    ], 64))
                  : (_unref(cur) === 2)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                        _createVNode(_component_el_form_item, {
                          label: _unref(texts)[5],
                          style: {"margin-bottom":"24px"}
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("div", _hoisted_11, [
                              _createElementVNode("span", _hoisted_12, _toDisplayString(props.customer.countryCode), 1),
                              _createElementVNode("span", _hoisted_13, _toDisplayString(_unref(form).customerMobile??''), 1)
                            ])
                          ]),
                          _: 1
                        }, 8, ["label"]),
                        _createVNode(_component_el_form_item, {
                          prop: "verificationCode",
                          label: _unref(texts)[2]
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_input, {
                              type: "text",
                              modelValue: _unref(form).verificationCode,
                              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_unref(form).verificationCode) = $event)),
                              modelModifiers: { trim: true },
                              placeholder: _unref(tips)[2],
                              maxlength: 6,
                              style: {"width":"320px"}
                            }, null, 8, ["modelValue", "placeholder"]),
                            _createVNode(_component_el_button, {
                              class: "codebtn",
                              type: "primary",
                              onClick: _cache[5] || (_cache[5] = ($event: any) => (_unref(getPhoneCode)({ customerMobile: _unref(form).customerMobile, bizType: 2, globalRoaming: __props.customer.countryCode }))),
                              disabled: _unref(count) > 0
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_unref(count)
                > 0 ? _unref(tip) : _unref(t)('获取验证码')), 1)
                              ]),
                              _: 1
                            }, 8, ["disabled"])
                          ]),
                          _: 1
                        }, 8, ["label"])
                      ], 64))
                    : _createCommentVNode("", true),
              _createVNode(_component_el_form_item, {
                prop: "newPassword",
                label: _unref(texts)[3]
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_14, [
                    _createVNode(_component_el_input, {
                      type: pwc.value ? 'password' : 'text',
                      modelValue: _unref(form).newPassword,
                      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_unref(form).newPassword) = $event)),
                      modelModifiers: { trim: true },
                      placeholder: _unref(tips)[3],
                      maxlength: 32,
                      autocomplete: "new-password"
                    }, null, 8, ["type", "modelValue", "placeholder"]),
                    _createElementVNode("img", {
                      src: pwc.value ? _unref(faEyeSlash) : _unref(faEye),
                      onClick: _cache[7] || (_cache[7] = ($event: any) => (pwc.value = !pwc.value)),
                      alt: "",
                      class: "abs btn eye primary fa"
                    }, null, 8, _hoisted_15)
                  ])
                ]),
                _: 1
              }, 8, ["label"]),
              _createVNode(_component_el_form_item, {
                prop: "repassword",
                label: _unref(texts)[4]
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_16, [
                    _createVNode(_component_el_input, {
                      type: pwc.value ? 'password' : 'text',
                      modelValue: _unref(form).repassword,
                      "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_unref(form).repassword) = $event)),
                      modelModifiers: { trim: true },
                      placeholder: _unref(tips)[4],
                      maxlength: 32
                    }, null, 8, ["type", "modelValue", "placeholder"]),
                    _createElementVNode("img", {
                      src: pwc.value ? _unref(faEyeSlash) : _unref(faEye),
                      onClick: _cache[9] || (_cache[9] = ($event: any) => (pwc.value = !pwc.value)),
                      alt: "",
                      class: "abs btn eye primary fa"
                    }, null, 8, _hoisted_17)
                  ])
                ]),
                _: 1
              }, 8, ["label"])
            ]),
            _: 1
          }, 8, ["model", "rules"]),
          _createElementVNode("div", _hoisted_18, [
            _createVNode(_component_el_button, {
              type: "primary",
              loading: _unref(loading),
              onClick: _unref(commit)
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref(t)('提交')), 1)
              ]),
              _: 1
            }, 8, ["loading", "onClick"])
          ])
        ], 64))
  ]))
}
}

})